import { Component, OnInit } from '@angular/core';
import {AuthService} from '../core/services/auth.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {AlertService} from '../core/services/alert.service';

@Component({
  selector: 'app-profil',
  templateUrl: './profil.component.html',
  styleUrls: ['./profil.component.scss']
})
export class ProfilComponent implements OnInit {

  public user = null;
  public loading = false;

  constructor(public authService: AuthService, public snack: MatSnackBar, public alertService: AlertService) {
    this.authService.currentUser.subscribe(user => {
      this.user = user;
    });
  }

  ngOnInit(): void {
    //this.loading = true;
    this.authService.getProfileData().subscribe(res => {
      this.bga = res['bga'];
    }, err => {
      console.log(err);
    })
  }

  public savingUser = false;
  saveUser() {
    this.savingUser = true;
    this.authService.updateProfilData(this.user).subscribe(res => {
      this.savingUser = false;
      this.snack.open('Profil erfolgreich gespeichert.', '', {panelClass: 'success-snackbar'});
      this.authService.currentUserSubject.next(this.user);
      sessionStorage.setItem('currentUser', JSON.stringify(this.user));
    }, err => {
      this.savingUser = false;
      this.alertService.showValidationError(err);
      //this.snack.open('Fehler beim Speichern.', '', {panelClass: 'danger-snackbar'});
      console.log(err);
    });
  }

  public savingPassword = false;
  public pwData = {
    currentPassword: '',
    newPassword: '',
    newPasswordRepeat: ''
  };
  savePassword() {
    this.savingPassword = true;
    this.authService.updatePassword(this.pwData).subscribe(res => {
      this.savingPassword = false;
      this.user.token = 'Basic ' + btoa(this.user.username + ':' + this.pwData.newPassword);
      this.authService.currentUserSubject.next(this.user);
      sessionStorage.setItem('currentUser', JSON.stringify(this.user));
      this.snack.open('Passwort erfolgreich aktualisiert.', '', {panelClass: 'success-snackbar'});
    }, err => {
      this.savingPassword = false;
      this.alertService.showValidationError(err);
      this.alertService.showCustomValidationError(err);
      console.log(err);
    });
  }

  public savingOrderEmail = false;
  public orderEmail = null;
  public saveOrderEmail() {
    this.authService.changeOrderEmail(this.orderEmail).subscribe(res => {
      this.snack.open('Bestell-E-Mail erfolgreich aktualisiert.', null, {panelClass: 'success-snackbar'});
    }, err => {
      console.log(err);
    })
  }

  public savingBga = false;
  public bga = null;
  public saveBga() {
    this.authService.changeBga(this.bga).subscribe(res => {
      this.snack.open('BGA erfolgreich aktualisiert.', null, {panelClass: 'success-snackbar'});
    }, err => {
      if(err.status == 901) {
        this.snack.open('Diese BGA ist bereits vergeben.', null, {panelClass: 'danger-snackbar'});
      }
      console.log(err);
    })
  }
}
